import React, { type HTMLAttributes, type ReactNode } from "react";
import { BaseInputV2AdornmentContext } from "src/components/BaseInputV2/BaseInputV2AdornmentContext.tsx";
import { css } from "@emotion/react";
import { selectClasses } from "src/components/SelectV2/SelectV2.constants.ts";

export const StartAdornment = ({
  startAdornment,
  disabled = false,
  isButton,
  ...rest
}: {
  startAdornment: ReactNode;
  disabled?: boolean;
  isButton: boolean;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      css={isButton ? buttonAdornmentStyles : null}
      className={selectClasses.startAdornment}
      onClick={(e) => {
        if (!isButton) {
          e.stopPropagation();
        }
      }}
      {...rest}
    >
      <BaseInputV2AdornmentContext.Provider
        value={{
          disabled,
          position: "end",
        }}
      >
        {startAdornment}
      </BaseInputV2AdornmentContext.Provider>
    </div>
  );
};

const buttonAdornmentStyles = () => css`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;
